module.exports = __webpack_public_path__ + "media/images/img/tag_company/casareal_tag-a8d16430ec2659a0bb1c9d3155078b09.png";